import { render, staticRenderFns } from "./BookingDetailPageInfo.vue?vue&type=template&id=6ecc62e2&scoped=true&"
import script from "./BookingDetailPageInfo.vue?vue&type=script&lang=js&"
export * from "./BookingDetailPageInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetailPageInfo.vue?vue&type=style&index=0&id=6ecc62e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc62e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ecc62e2')) {
      api.createRecord('6ecc62e2', component.options)
    } else {
      api.reload('6ecc62e2', component.options)
    }
    module.hot.accept("./BookingDetailPageInfo.vue?vue&type=template&id=6ecc62e2&scoped=true&", function () {
      api.rerender('6ecc62e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/BookingDetailPageInfo.vue"
export default component.exports